module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0071.jpg?v=16343616";